export const LOGIN_FORM_NAMES: any = {
  phoneNumber: "phoneNumber",
  password: "password",
};
